import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { PiAuthProvider } from "./contexts/PiAuthContext";

import Home from "./pages/Home";
import Directory from "./pages/Directory";
import ListBusiness from "./pages/ListBusiness";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Donate from "./pages/Donate";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import MembershipSuccess from "./pages/MembershipSuccess";
import Volunteer from "./pages/Volunteer";
import Opportunities from "./pages/Opportunities";
import Marketplace from "./pages/Marketplace";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <PiAuthProvider>
          <div className="App min-h-screen bg-[#EFEDE5]">
            <BrowserRouter>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/list-business" element={<ListBusiness />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/membership/success" element={<MembershipSuccess />} />
              <Route path="/sponsor/success" element={<MembershipSuccess />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </div>
        </PiAuthProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
